export const MAX_PRINT_SELECTION_COUNT = 300

export const printSelectionLimitMessage = (limit = MAX_PRINT_SELECTION_COUNT) =>
  `印刷は${limit.toLocaleString()}件までです。絞り込んでください。`
